import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const marketstack = defineConnector({
  identifier: "marketstack",
  name: "Marketstack",
  tagLine: "Stock market data",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.marketstack\\.com/.*",
  auth: (app) => queryAuth([{ name: "access_key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up at [Marketstack](https://marketstack.com/) and copy your API access key from the dashboard.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.marketstack.com/v1/tickers",
  },
});
